type Block={kind:"text";text:string;size:number;bold:boolean}|{kind:"table";rows:string[][];headRows:number;matrix:boolean};
export function wrapCanvasText(ctx:Pick<CanvasRenderingContext2D,"measureText">,text:string,width:number):string[]{
 const lines:string[]=[];
 for(const paragraph of text.split(/\n/)){
  let line="";
  for(const word of paragraph.split(/\s+/).filter(Boolean)){
   if(ctx.measureText(line?line+" "+word:word).width<=width){line=line?line+" "+word:word;continue;}
   if(line){lines.push(line);line="";}
   for(const char of word){if(line&&ctx.measureText(line+char).width>width){lines.push(line);line="";}line+=char;}
  }
  lines.push(line);
 }
 return lines.length?lines:[""];
}
export async function exportTournamentPng(article:HTMLElement,filename:string){
 if(document.fonts)await document.fonts.ready;
 const blocks:Block[]=[];
 const header=article.querySelector("header");
 if(header)for(const el of Array.from(header.children))if(el.textContent?.trim())blocks.push({kind:"text",text:el.textContent.trim(),size:el.tagName==="H1"?26:16,bold:el.tagName==="H1"});
 for(const section of article.querySelectorAll<HTMLElement>("[data-print-section]")){
  for(const el of section.querySelectorAll<HTMLElement>("h2,h3,table,p")){
   if(el.tagName==="TABLE"){
    const table=el as HTMLTableElement;const rows=Array.from(table.rows).map(r=>Array.from(r.cells).map(c=>(c.innerText||c.textContent||"").trim()));
    if(rows.length)blocks.push({kind:"table",rows,headRows:table.tHead?.rows.length??1,matrix:table.hasAttribute("data-print-matrix")});
   }else if(!el.closest("table")&&el.textContent?.trim())blocks.push({kind:"text",text:el.textContent.trim(),size:el.tagName==="H2"?22:el.tagName==="H3"?18:14,bold:el.tagName!=="P"});
  }
 }
 if(!blocks.some(b=>b.kind==="table"))throw Error("Нет таблиц для сохранения.");
 const maxColumns=Math.max(...blocks.map(b=>b.kind==="table"?Math.max(...b.rows.map(r=>r.length)):0));
 const width=Math.max(1100,maxColumns*80+300),padding=36,available=width-padding*2;
 const canvas=document.createElement("canvas");const ctx=canvas.getContext("2d");if(!ctx)throw Error("Браузер не поддерживает создание PNG.");
 const font=(size:number,bold=false)=>`${bold?700:400} ${size}px Arial, sans-serif`;
 type Layout={block:Block;y:number;height:number;lines?:string[];widths?:number[];cells?:string[][][];heights?:number[]};
 const layout:Layout[]=[];let y=padding;
 for(const block of blocks){
  if(block.kind==="text"){
   ctx.font=font(block.size,block.bold);const lines=wrapCanvasText(ctx,block.text,available);const height=lines.length*block.size*1.35+18;layout.push({block,y,height,lines});y+=height;
  }else{
   const n=Math.max(...block.rows.map(r=>r.length));ctx.font=font(20);
   let widths:number[];
   if(block.matrix)widths=[available*.07,available*.24,...Array.from({length:n-2},()=>available*.69/(n-2))];
   else if(block.rows[0][0]==="Место"&&block.rows[0][1]==="Команда")widths=[available*.07,available*.24,...Array.from({length:n-2},()=>available*.69/(n-2))];
   else {const natural=Array.from({length:n},(_,i)=>Math.min(310,Math.max(64,...block.rows.map(r=>ctx.measureText(r[i]??"").width+20))));if(block.rows[0][0]==="Место"){const total=natural.slice(1).reduce((a,b)=>a+b,0);widths=[78,...natural.slice(1).map(w=>w/total*(available-78))];}else{const total=natural.reduce((a,b)=>a+b,0);widths=natural.map(w=>w/total*available);}}
   const cells=block.rows.map((row,r)=>widths.map((w,i)=>{const teamCell=r>=block.headRows&&(block.matrix?i===1:block.rows[0][i]==="Команда");ctx.font=font(20,teamCell||r<block.headRows);return wrapCanvasText(ctx,row[i]??"",Math.max(12,w-16));}));
   const heights=cells.map(row=>Math.max(38,...row.map(cell=>cell.length*28+14)));const height=heights.reduce((a,b)=>a+b,0);layout.push({block,y,height,widths,cells,heights});y+=height+22;
  }
 }
 const height=y+padding;const scale=Math.min(2,16000/width,16000/height,Math.sqrt(32000000/(width*height)));
 if(scale<.5)throw Error("Слишком много данных для одной картинки. Сохраните разделы по отдельности.");
 canvas.width=Math.ceil(width*scale);canvas.height=Math.ceil(height*scale);ctx.scale(scale,scale);ctx.fillStyle="#ffffff";ctx.fillRect(0,0,width,height);ctx.textBaseline="top";
 for(const item of layout){
  if(item.block.kind==="text"){
   const textBlock=item.block;
   ctx.font=font(textBlock.size,textBlock.bold);ctx.fillStyle="#0f172a";ctx.textAlign="center";
   item.lines!.forEach((line,i)=>ctx.fillText(line,width/2,item.y+i*textBlock.size*1.35));
  }else{
   const tableBlock=item.block;let rowY=item.y;
   item.cells!.forEach((row,r)=>{
    let x=padding;const rowHeight=item.heights![r];const head=r<tableBlock.headRows;
    row.forEach((lines,c)=>{
     const w=item.widths![c];const diagonal=tableBlock.matrix&&!head&&c===r+1;
     ctx.fillStyle=head?"#cbd5e1":diagonal?"#dce2e8":(r-tableBlock.headRows)%2===0?"#ffffff":"#f1f3f5";ctx.fillRect(x,rowY,w,rowHeight);ctx.strokeStyle="#94a3b8";ctx.lineWidth=1;ctx.strokeRect(x,rowY,w,rowHeight);
     const teamCell=!head&&(tableBlock.matrix?c===1:tableBlock.rows[0][c]==="Команда");ctx.font=font(20,head||teamCell);ctx.fillStyle="#0f172a";
     ctx.textAlign="center";
     ctx.textBaseline="middle";
     const textY=rowY+rowHeight/2-(lines.length-1)*28/2;
     lines.forEach((line,i)=>ctx.fillText(line,x+w/2,textY+i*28));
     ctx.textBaseline="top";x+=w;
    });rowY+=rowHeight;
   });
  }
 }
 const blob=await new Promise<Blob>((resolve,reject)=>canvas.toBlob(value=>value?resolve(value):reject(Error("Не удалось создать PNG. Попробуйте выбрать меньше разделов.")),"image/png"));
 const url=URL.createObjectURL(blob);const link=document.createElement("a");link.href=url;link.download=filename;document.body.appendChild(link);link.click();link.remove();setTimeout(()=>URL.revokeObjectURL(url),30000);
}
